import { styled } from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';

export default styled.div`
  color: ${color.fixedWhite};
  background: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  font-weight: normal;
`;
